<template>
    <div class="min-h-screen bg-background text-text p-8 space-y-12">
        <!-- Title -->
        <header>
            <h1 class="text-4xl font-bold text-gold">UI Kit - Référence</h1>
            <p class="text-secondary mt-2">Aperçu des éléments de la charte graphique</p>
        </header>

        <!-- Typography -->
        <section>
            <h2 class="text-2xl font-semibold text-gold mb-4">Typographie</h2>
            <p class="text-lg">Paragraphe exemple - Lorem ipsum dolor sit amet.</p>
            <p class="text-secondary">Texte secondaire - Utilisé pour les sous-titres ou infos.</p>
        </section>

        <!-- Buttons -->
        <section>
            <h2 class="text-2xl font-semibold text-gold mb-4">Boutons</h2>
            <div class="flex gap-4 flex-wrap">
                <button class="btn-primary">Bouton
                    primaire</button>
                <button class="btn-accent">Bouton
                    accent</button>
                <button class="btn-gold">Bouton or</button>
                <button class="btn-fun">Bouton fun</button>
                <button class="btn-secondary">Bouton
                    secondaire</button>
            </div>
        </section>

        <!-- Cards -->
        <section>
            <h2 class="text-2xl font-semibold text-gold mb-4">Cartes</h2>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div class="card-primary">
                    <h3 class="text-xl font-semibold">Carte primaire</h3>
                    <p class="text-sm mt-2 text-text/80">Lorem ipsum dolor sit amet consectetur.</p>
                </div>
                <div class="card-accent">
                    <h3 class="text-xl font-semibold">Carte accent</h3>
                    <p class="text-sm mt-2">Lorem ipsum dolor sit amet consectetur.</p>
                </div>
                <div class="card-gold-premium">
                    <h3 class="text-xl font-semibold text-gold">Carte bord or</h3>
                    <p class="text-sm mt-2 text-secondary">Lorem ipsum dolor sit amet consectetur.</p>
                </div>
                <div class="card-secondary">
                    <h3 class="text-xl font-semibold text-white">Carte secondaire</h3>
                    <p class="text-sm mt-2 text-white">Lorem ipsum dolor sit amet consectetur.</p>
                </div>
                <div class="card-gold">
                    <h3 class="text-xl font-semibold text-primary">Carte gold</h3>
                    <p class="text-sm mt-2 text-primary">Lorem ipsum dolor sit amet consectetur.</p>
                </div>
                <div class="card-fun">
                    <h3 class="text-xl font-semibold text-white">Carte fun/alerte</h3>
                    <p class="text-sm mt-2 text-white">Lorem ipsum dolor sit amet consectetur.</p>
                </div>
            </div>
        </section>

        <!-- Icons -->
        <section>
            <h2 class="text-2xl font-semibold text-gold mb-4">Icônes</h2>
            <div class="flex gap-6">
                <HomeIcon class="w-8 h-8 text-primary" />
                <UserIcon class="w-8 h-8 text-accent" />
                <Cog6ToothIcon class="w-8 h-8 text-gold" />
            </div>
        </section>

        <!-- Table -->
        <section>
            <h2 class="text-2xl font-semibold text-gold mb-4">Tableau</h2>
            <table class="w-full border-collapse border border-secondary text-sm">
                <thead class="bg-primary text-white">
                    <tr>
                        <th class="border border-secondary px-4 py-2">Nom</th>
                        <th class="border border-secondary px-4 py-2">Email</th>
                        <th class="border border-secondary px-4 py-2">Rôle</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="border border-secondary px-4 py-2">John Doe</td>
                        <td class="border border-secondary px-4 py-2">john@example.com</td>
                        <td class="border border-secondary px-4 py-2">Admin</td>
                    </tr>
                    <tr class="bg-background/50">
                        <td class="border border-secondary px-4 py-2">Jane Smith</td>
                        <td class="border border-secondary px-4 py-2">jane@example.com</td>
                        <td class="border border-secondary px-4 py-2">User</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <!-- Alerts -->
        <section>
            <h2 class="text-2xl font-semibold text-gold mb-4">Alertes</h2>
            <div class="space-y-3">
                <div class="bg-primary text-white p-4 rounded-lg shadow">Info : Ceci est une alerte d'information.</div>
                <div class="bg-accent text-black p-4 rounded-lg shadow">Succès : Opération réussie.</div>
                <div class="bg-fun text-white p-4 rounded-lg shadow">Alerte : Un problème est survenu.</div>
            </div>
        </section>

        <!-- Form -->
        <section>
            <h2 class="text-2xl font-semibold text-gold mb-4">Formulaire</h2>
            <form class="space-y-4 max-w-md">
                <input type="text" placeholder="Nom"
                    class="w-full p-2 rounded-lg border border-secondary bg-background text-white focus:border-gold" />
                <input type="email" placeholder="Email"
                    class="w-full p-2 rounded-lg border border-secondary bg-background text-white focus:border-gold" />
                <textarea placeholder="Message"
                    class="w-full p-2 rounded-lg border border-secondary bg-background text-white focus:border-gold"></textarea>
                <button class="bg-gold hover:bg-gold/80 text-black px-4 py-2 rounded-lg shadow">Envoyer</button>
            </form>
        </section>
    </div>

    <div class="min-h-screen bg-background text-text p-8 space-y-12">
        <!-- Title -->
        <header>
            <p class="text-secondary mb-8">Aperçu des éléments de type titre</p>
        </header>

        <!-- Typography -->
        <section>
            <TiltedHeader>Typographie</TiltedHeader>
            <!-- contenu... -->
        </section>

        <!-- Buttons -->
        <section>
            <TiltedHeader>Boutons</TiltedHeader>
            <!-- contenu... -->
        </section>

        <!-- Cards -->
        <section>
            <TiltedHeader>Cartes</TiltedHeader>
            <!-- contenu... -->
        </section>

        <!-- Icons -->
        <section>
            <TiltedHeader>Icônes</TiltedHeader>
            <!-- contenu... -->
        </section>

        <!-- Table -->
        <section>
            <TiltedHeader>Tableau</TiltedHeader>
            <!-- contenu... -->
        </section>

        <!-- Alerts -->
        <section>
            <TiltedHeader>Alertes</TiltedHeader>
            <!-- contenu... -->
        </section>

        <!-- Form -->
        <section>
            <TiltedHeader>Formulaire</TiltedHeader>
            <!-- contenu... -->
        </section>
    </div>
</template>

<script setup>
import { HomeIcon, UserIcon, Cog6ToothIcon } from '@heroicons/vue/24/outline'
import TiltedHeader from '@/components/titles/TiltedHeader.vue'
</script>
